module.exports = __webpack_public_path__ + "static/media/correct-relative.3581014e.svg";